// 'success' 'error' 'warning' 'info'
export default {
  FETCH_SURCHARGE_BY_FEE_GROUP_SS: 'fetch_surcharges_by_fee_group_ss',
  CLEAR_SURCHARGE_BY_FEE_GROUP_SS: 'clear_surcharges_by_fee_group_ss',
};
